import ReviewRatings from './ReviewRatings.js';
import { useElasticData, useExtraData } from "./DataContext.js";
import {showRatings, pubAssessmentScore, LIBRARY_SUITABILITY, SCHOOL_SUITABILITY} from "../bookpage/helpers.js";

const SubRatings = () => {
    let { ratingsData } = useElasticData();
    let { _source, isGuestUser, isLibraryUser, isLibraryUserActual } = useExtraData();

    const r = _source;

    const showeval = showRatings(r);
    const assessmentScore = pubAssessmentScore(r);
    const schoolsAssessment = r.schools_pub_assessment;
    const showOutOfTenRating = assessmentScore > 0;
    const popularityPredicationExplain = r.libs_post > 0 ? "based on: book in hand review" : "based on: pre-publication assessment";

    const qualityMetricGraphicValues = (qm) => {
        let metric = [];
        for(let i = 1; i <= 10; i++) {
            metric[i] = i <= qm ? "highlighted" : "";
        }

        return metric;
    }

    return (
        <div className="subRatings">
            {isLibraryUserActual() && <>
                <div class="rating main columns wrap librariesRatings">
                    <div>
                        <strong>{`Suitability for ${isLibraryUser() ? 'libraries' : 'schools'}`}</strong>
                    </div>

                    {showOutOfTenRating && <div className="column">Predicted popularity<br /> {popularityPredicationExplain}</div>}

                    {showOutOfTenRating && <div className="column" title={`Predicted popularity: ${assessmentScore}/10`}><div className="qualityMetricText">{assessmentScore}/10</div><div className="qualityMetricGraphic">{qualityMetricGraphicValues(assessmentScore).map((h, i) => <span key={`${h}${i}`} className={`qualityMetricGraphicItem ${h}`}></span>)}</div></div>}
                    {r.suit_libraries == 0 && showeval && <div className="column libSuitRating">
                        <div className="suitabilityGraphic">
                            {[1,2,3].map((i, x) => <span key={`${x}${i}`} className={`suitabilityGraphicItem ${i == 2 ? 'wide' : ''}`} title={`Suitability for libraries: ${LIBRARY_SUITABILITY[0]}`}></span>)}
                        </div>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[0]}`}><img src="/assets/img/bookicon4.png"/></span>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[0]}`}><img src="/assets/img/bookicon2.png"/></span>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[0]}`}><img src="/assets/img/bookicon.png"/></span>
                    </div>}
                    {r.suit_libraries != 0 && showeval && <div className="column libSuitRating">
                        <div className="suitabilityGraphic">
                            {[1,2,3].map((i, x) => <span key={`${x}${i}`} className={`suitabilityGraphicItem ${i <= r.suit_libraries ? 'highlighted' : ''} ${i == 2 ? 'wide' : ''}`} title={`Suitability for libraries: ${LIBRARY_SUITABILITY[r.suit_libraries]}`}></span>)}
                        </div>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[r.suit_libraries]}`}><img src={`/assets/img/bookicon4${r.suit_libraries >= 3 ? '-checked': ''}.png`}/></span>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[r.suit_libraries]}`}><img src={`/assets/img/bookicon2${r.suit_libraries >= 2 ? '-checked': ''}.png`}/></span>
                        <span className="libSuitRatingItem" title={`Suitability for libraries: ${LIBRARY_SUITABILITY[r.suit_libraries]}`}><img src={`/assets/img/bookicon${r.suit_libraries >= 1 ? '-checked': ''}.png`}/></span>
                    </div>}
                </div>

                {ratingsData?.length > 0 && showeval && <ReviewRatings />}

                {showeval && r.distributor.value != 'ZZ89' && schoolsAssessment > 0 && <div className="rating main">
                    <div className="columns wrap" style={{marginTop:"1.5rem"}}>
                        {/* <div className="column"><strong>Suitability for schools</strong></div>
                        <div style={{textAlign:"right"}} className="column" title={`Schools popularity: ${schoolsAssessment}/10`}>
                            <div className="qualityMetricText">{schoolsAssessment}/10</div>
                        </div> */}
                        <div className="column"><strong>Schools popularity</strong></div>
                        <div style={{textAlign:"right"}} className="column" title={`Suitability: ${schoolsAssessment}/10`}>
                            <div className="qualityMetricText">{schoolsAssessment}/10</div>
                            <div className="qualityMetricGraphic">
                                {qualityMetricGraphicValues(schoolsAssessment).map((h, i) => <span key={`${h}${i}`} className={`qualityMetricGraphicItem ${h}`}></span>)}
                            </div>
                        </div>
                        {/* <div className="column" title={"Suitability for schools:\n" + SCHOOL_SUITABILITY[r.suit_schools]}>
                            <span className={r.suit_schools == 3 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 2 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 1 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 0 ? "checked" : ""}><label></label></span>
                        </div> */}
                    </div>
                </div>}
            </>}

            {isGuestUser && <div class="loginRequired"><a class="login">Log in</a> to view our ratings for this title.</div>}
            
            {!isGuestUser && !isLibraryUserActual() && (schoolsAssessment > 0 || showeval) && <>
                {r.suit_schools && <div className="rating main columns wrap">
                    <div className="column"><strong>Schools popularity</strong></div>
                    <div className="column" title={`Suitability: ${schoolsAssessment}/10`}>
                        <div className="qualityMetricText">{schoolsAssessment}/10</div>
                        <div className="qualityMetricGraphic">
                            {qualityMetricGraphicValues(schoolsAssessment).map((h, i) => <span key={`${h}${i}`} className={`qualityMetricGraphicItem ${h}`}></span>)}
                        </div>
                    </div>
                    {/* {showeval &&
                        <div className="column" title={"Suitability for schools:\n" + SCHOOL_SUITABILITY[r.suit_schools]}>
                            <span className={r.suit_schools == 3 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 2 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 1 ? "checked" : ""}><label></label></span>
                            <span className={r.suit_schools == 0 ? "checked" : ""}><label></label></span>
                        </div>
                    } */}
                </div>}

                {ratingsData?.length > 0 && <ReviewRatings />}
            </>}
        </div>
    );
}

export default SubRatings;
